import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

// Handle response errors (token is sent via HttpOnly cookie automatically)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (data) => api.post('/auth/register', data),
  getCurrentUser: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout')
};

// Customer API
export const customerAPI = {
  getAll: (params) => api.get('/customers', { params }),
  getOne: (id) => api.get(`/customers/${id}`),
  create: (data) => api.post('/customers', data),
  update: (id, data) => api.put(`/customers/${id}`, data),
  delete: (id) => api.delete(`/customers/${id}`),
  getStatistics: () => api.get('/customers/statistics'),
  getAreas: () => api.get('/customers/areas'),
  getWithNotes: () => api.get('/customers/with-notes'),
  getForMap: () => api.get('/customers/map')
};

// Agent API
export const agentAPI = {
  generateODT: (customerIds) => api.post('/agent/generate-odt', { customerIds }, { responseType: 'blob' }),
  batchUpdateStatus: (customerIds, status) => api.put('/agent/batch-status', { customerIds, status })
};

// CYTA Faults API
export const cytaFaultsAPI = {
  getStatus: () => api.get('/cyta-faults/status'),
  forceCheck: () => api.post('/cyta-faults/check')
};

// Industry News API
export const industryNewsAPI = {
  getNews: () => api.get('/industry-news'),
  refresh: () => api.post('/industry-news/refresh')
};

// System Health API
export const systemAPI = {
  getHealth: () => api.get('/system/health'),
  getErrors: (limit = 20) => api.get('/system/errors', { params: { limit } })
};

export default api;
